import { CustomColumn } from '../../../types/customColumn';
import { InventoryAdjustmentTableDTO } from '../../../types/inventory/adjustment/InventoryAdjustmentTypes';

export const inventoryAdjustmentColumns: CustomColumn<InventoryAdjustmentTableDTO>[] =
  [
    /**
     * 📝 Motivo
     */
    {
      Header: 'Motivo',
      accessor: 'reason',
      customCell: ({ row }) => (
        <div className="min-w-[240px] max-w-[320px]">
          <div className="font-medium text-black dark:text-white">
            {row.original.reason || '—'}
          </div>
        </div>
      ),
    },

    /**
     * 🏢 Sucursal
     */
    {
      Header: 'Sucursal',
      accessor: 'branchName',
      customCell: ({ row }) => (
        <div className="min-w-[180px]">
          <span className="text-gray-700 dark:text-gray-300 text-sm">
            {row.original.branchName || '—'}
          </span>
        </div>
      ),
    },

    /**
     * ✅ Estado
     */
    {
      Header: 'Estado',
      accessor: 'status',
      customCell: ({ row }) => {
        const status = row.original.status;

        const statusStyles: Record<string, string> = {
          Creado: 'bg-[#F9C107] text-[#212B36]',
          Finalizado: 'bg-[#3BA2B8] text-white',
          Aprobado: 'bg-[#3CA745] text-white',
          Rechazado: 'bg-[#DC3545] text-white',
          Cancelado: 'bg-[#637381] text-white',
          Revertido: 'bg-[#EFEFEF] text-[#212B36]',
        };

        const badgeColor =
          statusStyles[status] ?? 'bg-[#EFEFEF] text-[#212B36]';

        return (
          <div className="min-w-[150px]">
            <span
              className={`
                inline-flex
                whitespace-nowrap
                rounded-full
                px-3
                py-1
                text-xs
                font-medium
                uppercase
                ${badgeColor}
              `}
            >
              {status || '—'}
            </span>
          </div>
        );
      },
    },

    /**
     * 📅 Fecha
     */
    {
      Header: 'Fecha',
      accessor: 'createdDate',
      customCell: ({ row }) => (
        <div className="min-w-[140px]">
          <span className="text-gray-600 dark:text-gray-400 whitespace-nowrap text-sm">
            {row.original.createdDate || '—'}
          </span>
        </div>
      ),
    },

    /**
     * 🕒 Hora
     */
    {
      Header: 'Hora',
      accessor: 'createdTime',
      customCell: ({ row }) => (
        <div className="min-w-[120px]">
          <span className="text-gray-600 dark:text-gray-400 whitespace-nowrap text-sm">
            {row.original.createdTime || '—'}
          </span>
        </div>
      ),
    },
  ];
